import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import Popover from '@gik/ui/Popover';
import { User } from '@gik/core/models/gik/User';
import Link from '@/components/Link';
import SvgIcon from '@gik/ui/SvgIcon';

export const appHeaderDropdownBlockName = 'app-header-dropdown';

export interface IAppHeaderDropdownItem {
  label: string;
  value: string;
}

export interface IAppHeaderDropdownProps {
  user?: User;
  className?: string;
  title: string;
  links: IAppHeaderDropdownItem[];
}

export default function AppHeaderDropdown({ title, links, className }: IAppHeaderDropdownProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const bem = bemBlock(appHeaderDropdownBlockName);

  return (
    <Popover
      trigger={
        <div>
          <span>{title}</span>
          <SvgIcon name="ChevronDown" />
        </div>
      }
      isOpen={isOpen}
      triggerOnMouseEnter={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      noPad
      hasArrowIndicator={false}
      className={bem(null, null, className)}
    >
      <ul className={bem('nav')}>
        {links.map(link => {
          return (
            <li key={link.value}>
              <Link href={link.value}>
                <a>{link.label}</a>
              </Link>
            </li>
          );
        })}
      </ul>
    </Popover>
  );
}
